import Phaser from 'phaser';
import { GAME_H, GAME_W } from '../config';
import { ctxOf } from '../context';
import { SceneKeys } from './keys';
import { registerManifest } from '@/content/manifest';
import { ensureFontsIfAvailable } from '../wiring';

/** Loads the shared chapter manifest with a real progress bar, then starts Title + UI. */
export class PreloadScene extends Phaser.Scene {
  constructor() { super(SceneKeys.PRELOAD); }

  preload(): void {
    const bar = this.add.rectangle(GAME_W / 2, GAME_H / 2, 200, 6, 0x3a2a1e).setOrigin(0.5);
    const fill = this.add.rectangle(GAME_W / 2 - 100, GAME_H / 2, 0, 6, 0xe2c48c).setOrigin(0, 0.5);
    const label = this.add.text(GAME_W / 2, GAME_H / 2 + 16, '装载中… 0%', { fontFamily: 'sans-serif', fontSize: '12px', color: '#e2c48c' }).setOrigin(0.5);
    this.load.on(Phaser.Loader.Events.PROGRESS, (v: number) => {
      fill.width = Math.round(200 * v);
      label.setText(`装载中… ${Math.round(v * 100)}%`);
    });
    this.load.on(Phaser.Loader.Events.FILE_LOAD_ERROR, (file: Phaser.Loader.File) => {
      console.warn(`[load] failed: ${file.key} (${file.url})`);
    });
    registerManifest(this.load, 'shared');
    bar.setDepth(1);
  }

  create(): void {
    void ensureFontsIfAvailable().then(() => this.startGame());
  }

  private startGame(): void {
    const ctx = ctxOf(this);
    this.scene.launch(SceneKeys.UI);
    if (ctx.url.showcase) {
      this.scene.start(SceneKeys.SHOWCASE, { module: ctx.url.showcase });
      return;
    }
    this.scene.start(SceneKeys.TITLE);
  }
}
